"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionAttachmentResponseDtoToJSON = exports.RequisitionAttachmentResponseDtoFromJSONTyped = exports.RequisitionAttachmentResponseDtoFromJSON = exports.instanceOfRequisitionAttachmentResponseDto = exports.RequisitionAttachmentResponseDtoReportResultEnum = exports.RequisitionAttachmentResponseDtoCategoryEnum = void 0;
var runtime_1 = require("../runtime");
var RequisitionAttachmentResponseDtoReportRelease_1 = require("./RequisitionAttachmentResponseDtoReportRelease");
/**
 * @export
 */
exports.RequisitionAttachmentResponseDtoCategoryEnum = {
    AllPaperwork: 'all_paperwork',
    CarrierCouplesSummary: 'carrier_couples_summary',
    CollaborationForm: 'collaboration_form',
    CreditCardAuthorizationForm: 'credit_card_authorization_form',
    ClinicalSummaryReport: 'clinical_summary_report',
    DrugGeneSummary: 'drug_gene_summary',
    FamilyHistory: 'family_history',
    FfpeSpecimenRequestForm: 'ffpe_specimen_request_form',
    GeneticCounseling: 'genetic_counseling',
    GiaResultsTranscript: 'gia_results_transcript',
    GiaTranscript: 'gia_transcript',
    InsuranceCard: 'insurance_card',
    InsurancePaperwork: 'insurance_paperwork',
    Invoice: 'invoice',
    LetterOfMedicalNecessity: 'letter_of_medical_necessity',
    MedicalRecords: 'medical_records',
    OnlineRequisitionForm: 'online_requisition_form',
    Other: 'other',
    PapFapApplication: 'pap_fap_application',
    PathologyReport: 'pathology_report',
    PatientSummaryLetter: 'patient_summary_letter',
    PatientMedicalRecord: 'patient_medical_record',
    PaymentReceipt: 'payment_receipt',
    PersonalizedPrescribingReport: 'personalized_prescribing_report',
    PreliminaryReport: 'preliminary_report',
    PreviousResults: 'previous_results',
    Report: 'report',
    ReportCoverSheet: 'report_cover_sheet',
    SampleFailureLetter: 'sample_failure_letter',
    ScannedReqForm: 'scanned_req_form',
    ScannedReqFormImage: 'scanned_req_form_image',
    SecInsuranceCard: 'sec_insurance_card',
    SupplementalReport: 'supplemental_report',
    Waiver: 'waiver',
    ManagementGuideline: 'management_guideline',
    ResidualRiskTable: 'residual_risk_table'
};
/**
 * @export
 */
exports.RequisitionAttachmentResponseDtoReportResultEnum = {
    Positive: 'Positive',
    PotentiallyPositive: 'Potentially positive',
    CarrierPotentiallyPositive: 'Carrier potentially positive',
    IncreasedRisk: 'Increased risk',
    Carrier: 'Carrier',
    Uncertain: 'Uncertain',
    Negative: 'Negative',
    NegativePartial: 'Negative partial',
    Indeterminate: 'Indeterminate',
    Other: 'Other'
};
/**
 * Check if a given object implements the RequisitionAttachmentResponseDto interface.
 */
function instanceOfRequisitionAttachmentResponseDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfRequisitionAttachmentResponseDto = instanceOfRequisitionAttachmentResponseDto;
function RequisitionAttachmentResponseDtoFromJSON(json) {
    return RequisitionAttachmentResponseDtoFromJSONTyped(json, false);
}
exports.RequisitionAttachmentResponseDtoFromJSON = RequisitionAttachmentResponseDtoFromJSON;
function RequisitionAttachmentResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'contentType': !(0, runtime_1.exists)(json, 'contentType') ? undefined : json['contentType'],
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : json['data'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'positiveFinding': !(0, runtime_1.exists)(json, 'positiveFinding') ? undefined : json['positiveFinding'],
        'reportRelease': !(0, runtime_1.exists)(json, 'reportRelease') ? undefined : (0, RequisitionAttachmentResponseDtoReportRelease_1.RequisitionAttachmentResponseDtoReportReleaseFromJSON)(json['reportRelease']),
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
        'uuid': !(0, runtime_1.exists)(json, 'uuid') ? undefined : json['uuid'],
        'documentId': !(0, runtime_1.exists)(json, 'documentId') ? undefined : json['documentId'],
        'reportResult': !(0, runtime_1.exists)(json, 'reportResult') ? undefined : json['reportResult'],
        'isSharedWithPhysician': !(0, runtime_1.exists)(json, 'isSharedWithPhysician') ? undefined : json['isSharedWithPhysician'],
        'uploaderEmail': !(0, runtime_1.exists)(json, 'uploaderEmail') ? undefined : json['uploaderEmail'],
    };
}
exports.RequisitionAttachmentResponseDtoFromJSONTyped = RequisitionAttachmentResponseDtoFromJSONTyped;
function RequisitionAttachmentResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': value.category,
        'contentType': value.contentType,
        'data': value.data,
        'id': value.id,
        'name': value.name,
        'positiveFinding': value.positiveFinding,
        'reportRelease': (0, RequisitionAttachmentResponseDtoReportRelease_1.RequisitionAttachmentResponseDtoReportReleaseToJSON)(value.reportRelease),
        'url': value.url,
        'uuid': value.uuid,
        'documentId': value.documentId,
        'reportResult': value.reportResult,
        'isSharedWithPhysician': value.isSharedWithPhysician,
        'uploaderEmail': value.uploaderEmail,
    };
}
exports.RequisitionAttachmentResponseDtoToJSON = RequisitionAttachmentResponseDtoToJSON;
